import { useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  Clock, 
  CalendarDays, 
  Utensils, 
  Bus, 
  Map, 
  Send, 
  Plus, 
  ChevronRight, 
  ChevronLeft,
  PenTool,
  CheckCircle2,
  AlertCircle
} from 'lucide-react';

export default function DocEmployee() {
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: 'Inter, sans-serif', maxWidth: '800px', margin: '0 auto', padding: '40px 20px', color: '#1e293b' }}>
      
      {/* HEADER */}
      <div style={{ marginBottom: '40px', borderBottom: '1px solid #e2e8f0', paddingBottom: '20px' }}>
        <button onClick={() => navigate('/')} style={{ display:'flex', alignItems:'center', gap:'8px', border:'none', background:'transparent', color:'#64748b', cursor:'pointer', marginBottom:'15px', fontWeight:'600' }}>
          <ArrowLeft size={20} /> Retour Accueil
        </button>
        <h1 style={{ fontSize: '2rem', margin: 0, color: '#1e293b' }}>Guide Utilisateur <span style={{color:'#10b981'}}>Technicien</span></h1>
        <p style={{ color: '#64748b', marginTop: '10px', fontSize: '1.1rem' }}>
          Procédure pour la saisie des heures, des indemnités et des congés.
        </p>
      </div>

      {/* SECTION 1 : FEUILLE D'HEURES */}
      <div style={{ background: 'white', padding: '30px', borderRadius: '16px', border: '1px solid #e2e8f0', marginBottom: '30px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', color: '#10b981' }}>
          <div style={{ background: '#ecfdf5', padding: '10px', borderRadius: '10px' }}><Clock size={28} /></div>
          <h2 style={{ margin: 0, fontSize: '1.5rem' }}>1. Ma Feuille d'Heures</h2>
        </div>

        <div style={{ display:'flex', flexDirection:'column', gap:'25px' }}>
          
          {/* Étape 1 */}
          <div style={{ display:'flex', gap:'15px' }}>
            <div style={{ minWidth:'30px', height:'30px', background:'#10b981', color:'white', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold' }}>1</div>
            <div>
              <h3 style={{ margin:'0 0 5px 0', fontSize:'1.1rem' }}>Choisir la semaine</h3>
              <p style={{ margin:0, color:'#64748b' }}>Utilisez les flèches <strong style={{background:'#f1f5f9', padding:'2px 6px', borderRadius:'4px'}}><ChevronLeft size={12}/></strong> et <strong style={{background:'#f1f5f9', padding:'2px 6px', borderRadius:'4px'}}><ChevronRight size={12}/></strong> en haut de l'écran pour naviguer vers la semaine concernée.</p>
            </div>
          </div>

          {/* Étape 2 */}
          <div style={{ display:'flex', gap:'15px' }}>
            <div style={{ minWidth:'30px', height:'30px', background:'#10b981', color:'white', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold' }}>2</div>
            <div>
              <h3 style={{ margin:'0 0 5px 0', fontSize:'1.1rem' }}>Ajouter les chantiers</h3>
              <p style={{ margin:0, color:'#64748b' }}>
                Si votre planning est vide, sélectionnez un chantier dans la liste déroulante et appuyez sur le bouton <strong style={{color:'#2563eb', background:'#eff6ff', padding:'2px 8px', borderRadius:'4px'}}><Plus size={12} style={{verticalAlign:'middle'}}/></strong>.
              </p>
            </div>
          </div>

          {/* Étape 3 */}
          <div style={{ display:'flex', gap:'15px' }}>
            <div style={{ minWidth:'30px', height:'30px', background:'#10b981', color:'white', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold' }}>3</div>
            <div>
              <h3 style={{ margin:'0 0 5px 0', fontSize:'1.1rem' }}>Saisir les heures & Indemnités</h3>
              <p style={{ margin:'0 0 10px 0', color:'#64748b' }}>Remplissez vos heures jour par jour. En bas de page, gérez vos primes :</p>
              
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(200px, 1fr))', gap:'10px' }}>
                <div style={{ background:'#f0fdf4', padding:'10px', borderRadius:'8px', border:'1px solid #bbf7d0', display:'flex', alignItems:'center', gap:'10px' }}>
                  <Utensils size={20} className="text-green-700" />
                  <span style={{fontWeight:'600', color:'#15803d'}}>Panier Repas</span>
                </div>
                <div style={{ background:'#fffbeb', padding:'10px', borderRadius:'8px', border:'1px solid #fde68a', display:'flex', alignItems:'center', gap:'10px' }}>
                  <Bus size={20} className="text-amber-700" />
                  <span style={{fontWeight:'600', color:'#b45309'}}>Transport</span>
                </div>
                <div style={{ background:'#fffbeb', padding:'10px', borderRadius:'8px', border:'1px solid #fde68a', display:'flex', alignItems:'center', gap:'10px' }}>
                  <Map size={20} className="text-amber-700" />
                  <span style={{fontWeight:'600', color:'#b45309'}}>Trajet</span>
                </div>
              </div>
              <div style={{ marginTop:'10px', fontSize:'0.85rem', color:'#ef4444', display:'flex', alignItems:'center', gap:'6px' }}>
                <AlertCircle size={14} /> La zone (1 à 7) est calculée automatiquement. Vous n'avez rien à faire.
              </div>
            </div>
          </div>

          {/* Étape 4 */}
          <div style={{ display:'flex', gap:'15px' }}>
            <div style={{ minWidth:'30px', height:'30px', background:'#10b981', color:'white', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:'bold' }}>4</div>
            <div>
              <h3 style={{ margin:'0 0 5px 0', fontSize:'1.1rem' }}>Signer & Envoyer</h3>
              <p style={{ margin:0, color:'#64748b' }}>
                Une fois la semaine terminée, cliquez sur <strong style={{color:'#2563eb'}}><Send size={14} style={{verticalAlign:'middle'}}/> Signer & Envoyer</strong>. 
                Dessinez votre signature dans la zone blanche (<PenTool size={14} style={{verticalAlign:'middle'}}/>) et validez.
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* SECTION 2 : CONGÉS */}
      <div style={{ background: 'white', padding: '30px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', color: '#10b981' }}>
          <div style={{ background: '#ecfdf5', padding: '10px', borderRadius: '10px' }}><CalendarDays size={28} /></div>
          <h2 style={{ margin: 0, fontSize: '1.5rem' }}>2. Demande de Congés</h2>
        </div>
        <p style={{ lineHeight: '1.6', color: '#475569' }}>
          Pour poser des congés, rendez-vous dans le menu <strong>Congés</strong>. Cliquez sur <strong>Nouvelle demande</strong>, sélectionnez vos dates et le type (CP, Maladie, etc.). 
          <br/><br/>
          Vous pourrez suivre l'état de votre demande (Validée <CheckCircle2 size={14} color="#10b981" style={{display:'inline'}}/> ou En attente) directement sur votre tableau de bord.
        </p>
      </div>

    </div>
  );
}